import {
  Activity,
  BarChart3,
  Building2,
  Contact,
  Crosshair,
  Database,
  FileSpreadsheet,
  FileText,
  Grid3X3,
  Landmark,
  ListChecks,
  type LucideIcon,
  Scale,
  Settings,
  ShieldAlert,
  SlidersHorizontal,
  Target,
  Workflow,
} from "lucide-react";

// Sursa unica pentru sectiunile "Administrare": taburile din fiecare layout, intrarile din meniul
// lateral (navigation.ts) si segmentele rutelor din App.tsx se genereaza toate din acest fisier (D14,
// vezi docs/targetare/revizuire-plan-2026-09-11.md). Nu se mai tine o a doua lista in alta parte.

export type PaginaAdministrare = {
  id: string;
  eticheta: string;
  // segment relativ la baza grupului; "" inseamna pagina index a grupului
  segment: string;
  icon: LucideIcon;
};

export type GrupAdministrare = {
  id: string;
  titlu: string;
  scurt: string;
  baza: string;
  icon: LucideIcon;
  pagini: readonly PaginaAdministrare[];
};

export const GRUP_TARGETARE: GrupAdministrare = {
  id: "targetare",
  titlu: "Targetare NIS2",
  scurt: "Targetare",
  baza: "/administrare/targetare",
  icon: Target,
  pagini: [
    { id: "firme", eticheta: "Firme", segment: "", icon: Building2 },
    {
      id: "incadrare",
      eticheta: "Încadrare",
      segment: "incadrare",
      icon: ListChecks,
    },
    {
      id: "risc",
      eticheta: "Risc",
      segment: "risc",
      icon: ShieldAlert,
    },
    {
      id: "contacte",
      eticheta: "Contacte",
      segment: "contacte",
      icon: Contact,
    },
    { id: "tinte", eticheta: "Ținte", segment: "tinte", icon: Crosshair },
    {
      id: "activitate",
      eticheta: "Activitate",
      segment: "activitate",
      icon: Activity,
    },
    {
      id: "matrice",
      eticheta: "Matrice",
      segment: "matrice",
      icon: Grid3X3,
    },
    {
      id: "mapare",
      eticheta: "Mapare",
      segment: "mapare",
      icon: Workflow,
    },
    {
      id: "liste",
      eticheta: "Liste",
      segment: "liste",
      icon: FileSpreadsheet,
    },
    {
      id: "scoruri",
      eticheta: "Scoruri",
      segment: "scoruri",
      icon: SlidersHorizontal,
    },
    { id: "reguli", eticheta: "Reguli", segment: "reguli", icon: Scale },
  ],
} as const;

export const GRUP_ACTUALIZARE_DATE: GrupAdministrare = {
  id: "date",
  titlu: "Actualizare date",
  scurt: "Actualizare date",
  baza: "/administrare/date",
  icon: Database,
  pagini: [
    {
      id: "firme-onrc",
      eticheta: "ONRC",
      segment: "",
      icon: Building2,
    },
    {
      id: "contribuabili-anaf",
      eticheta: "ANAF",
      segment: "anaf",
      icon: Landmark,
    },
    {
      id: "bilanturi-mf",
      eticheta: "Bilanțuri",
      segment: "bilanturi",
      icon: FileText,
    },
    {
      id: "liste-oficiale",
      eticheta: "Liste oficiale",
      segment: "liste-oficiale",
      icon: FileSpreadsheet,
    },
    {
      id: "liste-neoficiale",
      eticheta: "Liste neoficiale",
      segment: "liste-neoficiale",
      icon: FileSpreadsheet,
    },
    {
      id: "nomenclatoare",
      eticheta: "Nomenclatoare",
      segment: "nomenclatoare",
      icon: ListChecks,
    },
    {
      id: "alte-surse",
      eticheta: "Alte surse",
      segment: "alte-surse",
      icon: Workflow,
    },
  ],
} as const;

export const GRUP_CONFIGURARE: GrupAdministrare = {
  id: "configurare",
  titlu: "Configurare",
  scurt: "Configurare",
  baza: "/administrare/configurare",
  icon: SlidersHorizontal,
  pagini: [
    {
      id: "prezentare",
      eticheta: "Prezentare",
      segment: "",
      icon: SlidersHorizontal,
    },
    { id: "setari", eticheta: "Setări", segment: "setari", icon: Settings },
  ],
} as const;

export const GRUP_STATISTICI: GrupAdministrare = {
  id: "statistici",
  titlu: "Statistici",
  scurt: "Statistici",
  baza: "/administrare/statistici",
  icon: BarChart3,
  pagini: [],
} as const;

export const GRUPURI_ADMINISTRARE: readonly GrupAdministrare[] = [
  GRUP_TARGETARE,
  GRUP_ACTUALIZARE_DATE,
  GRUP_CONFIGURARE,
  GRUP_STATISTICI,
];

export function caleAdministrare(
  grup: Pick<GrupAdministrare, "baza">,
  pagina: Pick<PaginaAdministrare, "segment">
): string {
  return pagina.segment ? `${grup.baza}/${pagina.segment}` : grup.baza;
}
